import { User } from '../types';

export const mockUser: User = {
  id: '1',
  name: 'Bryce',
  avatar: 'https://storage.googleapis.com/kiprweb/assets/bryce.png',
  level: 7,
  stats: {
    kipStreak: 7,
    avgScore: 4.2,
    completedThisWeek: 3,
  },
  skills: {
    communication: 85,
    accuracy: 78,
    empathy: 92,
  },
};